module.exports = __webpack_public_path__ + "img/4c7144b4-a94c-417e-976d-bcbb14781c9f.5219fe89.jpg";